import { axiosLevelTech } from '../axiosConfig';
import { showToast } from '@/services/notifications/toastService';

// -----------------------------
// TOAST MESSAGES
const TOASTS = {
  apiError: 'Something went wrong. Please try again.',
  networkError: 'Please check your connection and try again.',
};

// -----------------------------
// SHARED POST WRAPPER (also used by other services, e.g. consentService)
export const post = async (url: string, params: any, successMsg: string) => {
  return axiosLevelTech
    .post(url, params)
    .then((response) => {
      const res = response.data;

      if (res?.status === 'Success') {
        if (successMsg) {
          showToast('success', successMsg);
        }
      } else if (res?.status === 'Error') {
        showToast('error', res.message || TOASTS.apiError);
      }

      return res;
    })
    .catch((error) => {
      const msg = error.response?.data?.message || TOASTS.networkError;
      showToast('error', msg);
      throw new Error(error.response?.data?.message ?? error.message);
    });
};

// -----------------------------
// API: INITIALISE APP
export const initialiseApp = async () => {
  return axiosLevelTech
    .get('/api/app/Initialise')
    .then((res) => res.data)
    .catch((error) => {
      const msg = error.response?.data?.message || TOASTS.networkError;
      showToast('error', msg);
      throw new Error(error.response?.data?.message ?? error.message);
    });
};

// -----------------------------
// API: MARK NOTIFICATIONS AS READ
export const markNotificationsAsRead = async () => {
  return post('/api/notification/MarkAsRead', {}, '');
};
